import { EConstantElementType } from './EConstantElementType';
import { EItemType } from './EItemType';

class EItemTypeExt {
    static isDownCabinet(identifier: EItemType): boolean {
        return this.getConstantElementType(identifier) === EConstantElementType.BaseCabinet;
    }

    static isHighCabinet(identifier: EItemType): boolean {
        return this.getConstantElementType(identifier) === EConstantElementType.HighCabinet;
    }

    static isWallCabinet(identifier: EItemType): boolean {
        return this.getConstantElementType(identifier) === EConstantElementType.WallCabinet;
    }

    static isPanelSideWithGrooves(identifier: EItemType): boolean {
        const groovesPanelSide: EItemType[] = [EItemType.PSSG, EItemType.PSDG];
        return groovesPanelSide.includes(identifier);
    }

    private static panelSideTypes: EItemType[] = [EItemType.PS, EItemType.PSC, EItemType.PSH, EItemType.PSHG, EItemType.PSG, EItemType.PSSG, EItemType.PSDG, EItemType.PSW];

    static isPanelSide(identifier: EItemType): boolean {
        return this.panelSideTypes.includes(identifier);
    }

    static hasPanelSideFurnitureHeight(identifier: EItemType): boolean {
        const sideTypesFurnitureHeight: EItemType[] = [EItemType.PSC, EItemType.PSH, EItemType.PSW, EItemType.PSSG, EItemType.PSDG];
        return sideTypesFurnitureHeight.includes(identifier);
    }

    private static getConstantElementType(identifier: EItemType): EConstantElementType {
        switch (identifier) {
            case EItemType.C:
            case EItemType.CSI:
            case EItemType.CHO:
            case EItemType.CS:
            case EItemType.CFI:
                return EConstantElementType.BaseCabinet;
            case EItemType.CH:
            case EItemType.CSH:
                return EConstantElementType.HighCabinet;
            case EItemType.CW:
            case EItemType.CE:
            case EItemType.CSW:
            case EItemType.CFE:
            case EItemType.CD:
            case EItemType.CWD:
            case EItemType.CM:
                return EConstantElementType.WallCabinet;
            default:
                return EConstantElementType.Global;
        }
    }
    
}

export default EItemTypeExt;
